import { EXPRESS_API } from 'configs/api/expressApi';
import { useToastError } from './useToastError';

interface MoveMultipleVideoResponse {
  fulfilled: string[];
  rejected: string[];
}

interface PostData {
  copy: boolean;
  videoFolder: string;
  ids: number[];
  fromCompany?: boolean;
}

interface MoveCopyProps {
  onSuccess?: Function;
}

export const useVideoMoveCopyMultiple = ({
  onSuccess = () => {},
}: MoveCopyProps) => {
  const { showError } = useToastError();

  const mutateMultiple = async (body: PostData) => {
    try {
      const res = await EXPRESS_API.put(`videos/move`, body);

      const data: MoveMultipleVideoResponse = res.data;
      if (data && (!data.rejected || !data.rejected.length)) {
        onSuccess();
      }

      return data;
    } catch (err) {
      showError(err);
      return Promise.reject({
        loading: false,
        error: 'Something went wrong!',
      });
    }
  };

  return {
    mutateMultiple,
  };
};
